export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const asStringOrNull = (value: unknown): string | null =>
  typeof value === 'string' ? value : null;

export const asStringOrUndefined = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined;

export const asString = (value: unknown, fallback = ''): string =>
  typeof value === 'string' ? value : fallback;

export const toStringOrNull = (value: unknown): string | null =>
  typeof value === 'string' ? value : null;

export interface NamedEntity {
  name: string;
}

export function isNamedEntity(value: unknown): value is NamedEntity {
  return (
    typeof value === 'object' &&
    value !== null &&
    'name' in value &&
    typeof (value as { name: unknown }).name === 'string'
  );
}
